import React from 'react'
import { CDN_URL, SALESFORCE_TYPES } from '~/core/constants'

const accountSvg = `${CDN_URL}/salesforce/account.svg`
const leadSvg = `${CDN_URL}/salesforce/lead.svg`
const contactSvg = `${CDN_URL}/salesforce/contact.svg`
const opportunitySvg = `${CDN_URL}/salesforce/opportunity.svg`

const SalesforceIcon = ({ type }) => {
  switch (type) {
    case SALESFORCE_TYPES.ACCOUNT:
      return <img src={accountSvg} />
    case SALESFORCE_TYPES.CONTACT:
      return <img src={contactSvg} />
    case SALESFORCE_TYPES.LEAD:
      return <img src={leadSvg} />
    case SALESFORCE_TYPES.OPPORTUNITY:
      return <img src={opportunitySvg} />
    default:
      return null
  }
}

export default SalesforceIcon
